package uz.ferro.erp.feature.visit.model

import kotlinx.serialization.Serializable

@Serializable
data class CustomerDto (
    val id: String,
    val uniqueCode: String?,
    val name: String?,
    val aliasName: String?,
)